module.exports = {"id":"143632","name":"Volkan Demirel","rating":"75","photo":"./data/images/photos/1/143632.png","club":{"name":"Fenerbahçe","logo":"./data/images/clubs/Fenerbahce.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VolkanDemirel0.json
// module id = 4303
// module chunks = 0